import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Features } from '../components/Features';
import { Rules } from '../components/Rules';
import { Organization } from '../components/Organization';
import { Pricing } from '../components/Pricing';
import { AtmosphereStrip } from '../components/AtmosphereStrip';
import { Gallery } from '../components/Gallery';
import { CTA } from '../components/CTA';
export function Home() {
  return <main data-id="element-284">
      <Hero data-id="element-285" />
      <About data-id="element-286" />
      <Features data-id="element-287" />
      <Rules data-id="element-288" />
      <Organization data-id="element-289" />
      <Pricing data-id="element-290" />
      <AtmosphereStrip data-id="element-291" />
      <Gallery data-id="element-292" />
      <CTA data-id="element-293" />
    </main>;
}